'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _CssBaseline = require('./CssBaseline');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_CssBaseline).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/material-ui/CssBaseline/index.js
// module id = 1423
// module chunks = 35783957827783